'use client'


import { Phone } from 'lucide-react'
import { usePathname } from 'next/navigation'
import { navigateUrl } from '@/utils/client-request'

export default function SubHeader({ vendor }: { vendor?: any }) {
  const pathname = usePathname() || ''
  const banner = vendor?.headBanner
  return (
    <div className="border-b border-foreground/5 bg-cream">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10 min-h-9 py-1.5 md:py-0 flex items-center justify-center md:justify-between gap-4 text-[12px] text-foreground/55">
        <div className="flex items-center gap-5 min-w-0 justify-center md:justify-start">
          {banner ? (
            <span className="inline-flex items-center gap-2 font-medium min-w-0 text-center md:text-left text-foreground/70">
              <span className="relative w-1.5 h-1.5 shrink-0">
                <span className="absolute inset-0 rounded-full bg-emerald-500" />
                <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping" />
              </span>
              <span className="truncate">{banner}</span>
            </span>
          ) : vendor?.phone ? (
            <a href={`tel:${vendor.phone}`} className="inline-flex items-center gap-1.5 hover:text-foreground transition-colors">
              <Phone className="h-3.5 w-3.5" />
              {vendor.phone}
            </a>
          ) : null}
        </div>
        <div className="hidden md:flex items-center gap-5 shrink-0">
          <a href={navigateUrl('/order/check', pathname)} className="hover:text-foreground transition-colors">Захиалга хянах</a>
          {banner && vendor?.phone && (
            <a href={`tel:${vendor.phone}`} className="inline-flex items-center gap-1.5 hover:text-foreground transition-colors">
              <Phone className="h-3.5 w-3.5" />
              {vendor.phone}
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
